module.exports = __webpack_public_path__ + "img/action4.e26674d8.jpg";